import styles from '../styles/components/modal.module.css';
import { ReactComponent as CloseIcon } from "../assets/close.svg";


interface ComponentProps {
    children: React.ReactNode;
    cancel: Function;
    style?: {};
    zIndex?: number;
};


export default function Modal({children, cancel, style = {}, zIndex = 100}: ComponentProps) {
    return <>
        <div className={styles.bg} onClick={() => cancel()} style={{zIndex: zIndex}}/>
        <div className={styles.body} style={{...style, zIndex: zIndex + 1}}>
            <CloseIcon className={styles.cancel_button} onClick={() => cancel()}/>
            {children}
        </div>
    </>;
};